export default "/ressources/logged/img/icon/svg/office365.svg";